module.exports = __webpack_public_path__ + "static/media/rua_al_hijrah_1.df54bd81.jpg";